import { render, staticRenderFns } from "./questionPaper1.vue?vue&type=template&id=011bb941&scoped=true"
import script from "./questionPaper1.vue?vue&type=script&lang=js"
export * from "./questionPaper1.vue?vue&type=script&lang=js"
import style0 from "./questionPaper1.vue?vue&type=style&index=0&id=011bb941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011bb941",
  null
  
)

export default component.exports